import ApiData from '@/api/class/ApiData'
import { responseType } from 'complex-require/src/Rule'

const contractLockApi = {
  refresh: new ApiData<[{
    guarantorId: string
  }], responseType>({
    name: '刷新签约状态',
    url: 'web/cs-guarantor/refresh/sign/status',
    urlConfig: {
      pre: '',
      service: 'ufo/cs/'
    },
    method: 'get',
    data: ['inherit']
  }),
  pushCredit: new ApiData<[{
    guarantorId: string
  }], responseType>({
    name: '推送征信授权书',
    url: 'web/cs-guarantor/contract/sign/credit-accredit',
    urlConfig: {
      pre: '',
      service: 'ufo/cs/'
    },
    method: 'get',
    data: ['inherit']
  }),
  pushCommitment: new ApiData<[{
    guarantorId: string
  }], responseType>({
    name: '推送担保承诺函',
    url: 'web/cs-guarantor/contract/sign/guarantee-commitment',
    urlConfig: {
      pre: '',
      service: 'ufo/cs/'
    },
    method: 'get',
    data: ['inherit']
  }),

}

export default contractLockApi
